// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"279":"6c44d60f","937":"eabe11fc"}[chunkId] || chunkId) + "." + {"167":"108111ce7839ea19","229":"9ccb8c7f60ea9c90","279":"adc9607aaad459b1","937":"9a32cf2139072bf3"}[chunkId] + ".js";
};